import React from "react";
import { useNavigate } from "react-router-dom";
import searchIcon from "../assets/images/Search.svg";
import notofication from "../assets/images/notofication.svg";
import { menubar } from "../assets/icons";
import { routes } from "../helpers/constants";
import { useSidebar } from "../content/SidebarContent";

const PageHeader = ({
  title,
  description,
  tabs = [],
  activeTab,
  onTabChange,
  onOpenSidebar,
  hasSearch = false,
  onSearchChange = () => {},
}) => {
  const { setIsSidebarOpen } = useSidebar();
  const navigate = useNavigate();

  return (
    <div
      className={`bg-blue text-white flex items-end gap-4 md:px-6 px-3 py-3 md:py-4 w-full ${
        tabs.length ? "h-[185px]" : "h-[150px]"
      } md:h-[150px] !pb-0 lg:h-[200px] flex-shrink-0`}
    >
      {/* Sidebar toggle for mobile */}
      {onOpenSidebar && (
        <div
          className="menu block lg:hidden pt-2 h-[86%] lg:h-[83%]"
          onClick={() => setIsSidebarOpen(true)}
        >
          {menubar}
        </div>
      )}

      <div
        className={`w-[calc(100%-40px)] lg:w-full flex md:flex-row flex-col items-start ${
          tabs.length ? "justify-between" : "justify-start"
        } md:justify-between gap-4 lg:gap-y-4 md:gap-y-[30px] flex-wrap h-[86%] lg:h-[83%] header-content`}
      >
        {/* Title + Description */}
        <div className="flex flex-col items-start w-full md:w-[calc(100%-315px)] lg:w-[calc(100%-316px)]">
          <h1 className="text-sub-h1 mb-1 text-white">{title}</h1>
          {description && (
            <p className="text-p font-semibold text-white mb-0">
              {description}
            </p>
          )}
        </div>

        {/* Search + Notification */}
        <div className="flex lg:flex-col justify-between md:justify-end items-center lg:items-end gap-4 w-full md:w-fit">
          {hasSearch && (
            <div className="rounded-full border-2 border-white flex items-center gap-3 px-2 pe-3 py-2 min-w-[calc(100%-60px)] md:min-w-[200px] lg:min-w-[300px]">
              <img
                src={searchIcon}
                alt="search"
                className="w-[20px] md:w-[32px] h-[20px] md:h-[32px]"
              />
              <input
                type="text"
                placeholder="Search"
                className="text-sub_span text-white-vlight w-full border-none outline-none font-semibold bg-transparent"
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          )}
          <div
            onClick={() => navigate(routes.notification)}
            className={`notofication-icon flex-none w-[40px] h-[40px] rounded-full border border-white flex items-center justify-center ${
              hasSearch ? "" : "ml-auto mf:ml-0 mt-0 lg:mt-[68px]"
            }`}
          >
            <img
              src={notofication}
              alt="notification"
              className="w-[20px] h-auto"
              onClick={() => navigate(routes.notification)}
            />
          </div>
        </div>

        {/* Optional Tabs */}
        {tabs.length > 0 && (
          <div className="w-full overflow-hidden">
            <div className="flex gap-6 w-full overflow-x-auto">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => onTabChange?.(tab)}
                  className={`relative whitespace-nowrap px-2 py-1 text-white transition-all duration-300 ease-in-out ${
                    activeTab === tab
                      ? 'font-semibold text-white after:content-[""] after:absolute after:bottom-0 after:left-full after:-translate-x-1/2 after:w-full after:h-[4px] after:bg-[#D1E6FF] after:rounded-tl-[4px] after:rounded-tr-[4px]'
                      : "font-semibold text-gray"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
